import { NodeHeaders } from 'api/NodeHeaders'
import { fetchCurrentAuthorizedProfileSharingAvailableApi } from 'api/profile/fetchCurrentAuthorizedProfileSharingAvailableApi'

export const FETCH_CURRENT_AUTHORIZED_PROFILE_SHARING_AVAILABLE =
  'FETCH_CURRENT_AUTHORIZED_PROFILE_SHARING_AVAILABLE' as const

export const fetchCurrentAuthorizedProfileSharingAvailableAction = (
  headers?: NodeHeaders
) => ({
  type: FETCH_CURRENT_AUTHORIZED_PROFILE_SHARING_AVAILABLE,
  promise: () => fetchCurrentAuthorizedProfileSharingAvailableApi(headers),
})
